//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum, NewsPostIconEnum } from './Enums';

export class NewsInputItem extends ItemBase {
    BodyHTML: string | null = null;
    Category: string | null = null;
    Color: EventColorEnum = EventColorEnum.Beach;
    Icon: NewsPostIconEnum = NewsPostIconEnum.Airplane;
    PublishDate: string = "1970-01-01T00:00:00";
    IsSticky: boolean = false;
    Title: string | null = null;
    TeacherID: string | null = null;
    ShowOnStudentPortal: boolean = false;
    ShowOnTeacherPortal: boolean = false;
    ShowOnBlog: boolean = false;

    constructor(initializer?: Partial<NewsInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "NewsInputItem";
}
